import PropTypes from 'prop-types';
import { DB_PREFIX } from './constants';

export default PropTypes.shape({
  [DB_PREFIX]: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    photoURL: PropTypes.string,
    dateOfBirth: PropTypes.string,
    gender: PropTypes.string,
    mobilePhone: PropTypes.string,
    title: PropTypes.string,
    nationaly: PropTypes.string,
  }),
});
